import { useEffect, useState } from "react";

import useCustomSelector from "@redux/hooks/useCustomSelector";
import useActionCreator from "@redux/hooks/useActionCreator";

import { VendorState } from "@reducers/types/procurements/vendor-state";
import { capitalizeFirstLetter } from "@utils/capitalize";

interface UseVendorList {
  vendorState: VendorState;
  handleQuery: (key: string, value: number | string) => void;
  ClearQueries: () => void;
  query: any;
}

export const useVendorList = (
  forDropdown: boolean = false,
  approvalStatus?: string,
): UseVendorList => {
  const { vendorFetchActionHandler } = useActionCreator();

  const [query, setQuery] = useState({
    page: 1,
    size: forDropdown ? 10000 : 10,
    search: "",
    approvalStatus: capitalizeFirstLetter(approvalStatus || "") || null,
  });

  const handleQuery = (key: string, value: number | string) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  const ClearQueries = () => {
    const initialQueries = {
      search: "",
      approvalStatus: null,
      startDate: "",
      endDate: "",
    } as any;
    setQuery(initialQueries);
  };

  const vendorState = useCustomSelector(
    (store) => store.procurements.vendorState,
  );

  useEffect(() => {
    vendorFetchActionHandler(query);
  }, [query]);

  return {
    handleQuery,
    ClearQueries,
    query,
    vendorState,
  };
};
